import { IOffer } from '../../../types/offer';

export function getFlatTitle(offer: IOffer) {
  const { isApartments, flatType, roomsCount } = offer;
  if (flatType === 'studio') {
    return isApartments ? 'Апартаменты-студия' : 'Студия';
  }

  if (flatType === 'openPlan') {
    return 'Своб. планировка';
  }

  if (!roomsCount) {
    return '';
  }

  if (roomsCount > 5) {
    return 'Многокомнатная квартира';
  }

  return `${roomsCount}-комн. ${isApartments ? 'апартаменты' : 'квартира'}`;
}
